import { isTabCloseProtected } from './tabCloseGuards';
import type { Tab } from '../../../types/tabs';
import { MAX_OPEN_TABS } from '../config/tabKeepAlive';

const lastAccessedTime = (tab: Tab): number => {
  const value = tab.lastAccessed;
  if (value instanceof Date) {
    const time = value.getTime();
    return Number.isNaN(time) ? 0 : time;
  }
  const parsed = new Date(value as unknown as string).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

/**
 * Mantém no máximo `maxOpen` abas. Se passar, fecha as não favoritadas
 * há mais tempo (LRU). Nunca fecha `isPinned` nem `protectPath`.
 * Preserva a ordem das abas restantes.
 */
export function enforceOpenTabLimit(
  tabs: Tab[],
  protectPath?: string | null,
  maxOpen: number = MAX_OPEN_TABS,
): Tab[] {
  if (tabs.length <= maxOpen) return tabs;

  const overflow = tabs.length - maxOpen;
  const evictable = tabs
    .filter((tab) => !tab.isPinned && tab.path !== protectPath && !isTabCloseProtected(tab.path))
    .sort((a, b) => lastAccessedTime(a) - lastAccessedTime(b));

  if (evictable.length === 0) return tabs;

  const toEvict = new Set(evictable.slice(0, overflow).map((tab) => tab.path));
  return tabs.filter((tab) => !toEvict.has(tab.path));
}
